/**
 * Auth context + hook (split from `AuthProvider.tsx` the same way
 * `theme.ts`/`ThemeProvider.tsx` are split, so the component file keeps
 * fast-refresh).
 */

import { createContext, useContext } from 'react';

import type { AuthUser, Session } from './types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: AuthStatus;
  isAuthenticated: boolean;
  session: Session | null;
  user: AuthUser | null;
  /** Adopt an already-obtained session (email/password or social sign-in). */
  signIn: (session: Session) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
